import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

/*
Replaced sanitize-html with xss to reduce the client bundle size
(~200KB vs ~50KB). Unlike sanitize-html, xss works isomorphically without requiring jsdom or postcss,
making it suitable for both server-side rendering and client-side execution without any additional configuration.
*/
import xss from 'xss'

const SanitizedHtml = React.forwardRef(
    ({html, as: Component = Box, sanitize = false, ...props}, ref) => {
        const sanitizedHtml = sanitize ? xss(html || '') : html

        return (
            <Component
                ref={ref}
                className="editorial--html-block"
                {...props}
                dangerouslySetInnerHTML={{__html: sanitizedHtml}}
            />
        )
    },
)

SanitizedHtml.propTypes = {
    html: PropTypes.string,
    as: PropTypes.elementType,
    sanitize: PropTypes.bool,
}

SanitizedHtml.displayName = 'SanitizedHtml'

export default SanitizedHtml
